var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[([_vm.PropertyFieldType.String, _vm.PropertyFieldType.Email, _vm.PropertyFieldType.Phone].includes(_vm.propertyType))?_c('text-input',{attrs:{"setup":{
      'func': _vm.setModel,
      'args': {
        'model': this,
        'key': 'propValue',
        'prefix': 'set_property_',
      }
    }}}):_vm._e(),([_vm.PropertyFieldType.URL].includes(_vm.propertyType))?_c('text-input',{attrs:{"setup":{
      'func': _vm.setModel,
      'args': {
        'model': this,
        'key': 'propValue',
        'prefix': 'set_property_',
        'validation': 'required|url:require_protocol'
      }
    }}}):(_vm.propertyType === _vm.PropertyFieldType.Number || _vm.propertyType === _vm.PropertyFieldType.Double)?_c('number-input',{attrs:{"setup":{
      'func': _vm.setNumberValue,
      'args': {
        'model': this,
        'key': 'propValue',
        'min': Number.MIN_SAFE_INTEGER,
        'prefix': 'set_property_',
        'max': _vm.targetProperty.name === 'DISCOUNT' ? 100 : Number.MAX_SAFE_INTEGER,
      }
    }}}):([_vm.PropertyFieldType.Date, _vm.PropertyFieldType.Time, _vm.PropertyFieldType.DateTime].includes(_vm.propertyType))?_c('div',[_c('div',{staticClass:"mt-5"},[_c('field-title',{staticClass:"mb-2",attrs:{"title-key":"set_property_value"}}),_c('picker',{staticClass:"w-full default-border-picker",attrs:{"format":_vm.pickerFormat,"clearable":false,"time24hr":true},model:{value:(_vm.propValue),callback:function ($$v) {_vm.propValue=$$v},expression:"propValue"}})],1)]):(_vm.propertyType === _vm.PropertyFieldType.Flag)?_c('switch-input',{attrs:{"setup":{
      'func': _vm.setModel,
      'args': {
        'model': this,
        'key': 'propValue',
        'prefix': 'set_property_',
        'inline': false,
        'supportButtons': false
      },
    }},scopedSlots:_vm._u([{key:"checkedChildren",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t((_vm.propValue + "_value_option")))+" ")]},proxy:true},{key:"unCheckedChildren",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t((_vm.propValue + "_value_option")))+" ")]},proxy:true}])}):_vm._e(),(_vm.propertyType === _vm.PropertyFieldType.Files)?[_c('upload-media-descriptors',{attrs:{"target-id":_vm.mediaTargetId,"value":_vm.propValue},on:{"on-files-update":function($event){_vm.propValue = $event}}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }